<template>
    <form>
        <label>
            <span>Topic</span>
            <input v-model="parameters.topic">
        </label>
        <label>
            <span>Description</span>
            <textarea v-model="parameters.description"/>
        </label>
        <label>
            <span>Author</span>
            <input v-model="parameters.author">
        </label>
        <label>
            <span>Minimum Slides</span>
            <input type="number" v-model="parameters.minimumSlides">
        </label>
        <label>
            <span>Maximum Slides</span>
            <input type="number" v-model="parameters.maximumSlides">
        </label>
<!--        <label>-->
<!--            <span>Model</span>-->
<!--            <select v-model="parameters.model">-->
<!--                <option value="gpt-3.5-turbo">gpt-3.5-turbo</option>-->
<!--                <option value="gpt-4-1106-preview">gpt-4-1106-preview</option>-->
<!--            </select>-->
<!--        </label>-->
        <button @click.prevent="generate()" :class="{isLoading:generatingStatus.status.name=='pending'}">
            Generate
        </button>
<!--        {{ generatingStatus.status }}-->

    </form>
</template>
<script>
import ReactivePromiseStatus from "reactive-promise-status";
import {Api} from "@/api";

export default {
    data() {
        return {
            parameters: {
                topic: '',
                description: '',
                author: '',
                minimumSlides: 5,
                maximumSlides: 10,
                format: 'pptx',
                model: 'gpt-4.1-mini'
            },
            generatingStatus: new ReactivePromiseStatus(),
        }
    }, methods: {
        async generate() {
            window.gtag('event','generate', {params:this.parameters})
            // try {
            //     await this.$store.state.user;
            // } catch (e) {
            //     this.$emit('show-login-modal');
            //     return;
            // }
            this.generatingStatus.promise = this.generateStart();
            await this.generatingStatus.promise;
        },
        async generateStart() {
            const response = await Api.presentation.generate(this.parameters)
            var parser = new DOMParser();
            var doc = parser.parseFromString(response, "application/xml");
            console.log(doc);
            this.$emit('generated', doc);
        },
    }
}
</script>
<style lang="scss" scoped>
form {
    max-width: 800px;
    margin: auto;
}
</style>
